// Moved and renamed from Resource/ResourceSimilarSearch.js
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useState } from "react";
import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import TimeAgo from "react-timeago";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { MEDIA_URL } from "../../configs";
import AuthLayout from "../../components/AuthLayout/AuthLayout";
import { setMessage } from "../../redux/actions/message";
import format from "../../helpers/format";
import axios from "axios";

dayjs.extend(relativeTime);


function SimilarImage(props) {
  const dispatch = useDispatch();
  const { message, messageType } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      // Create preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSearch = async () => {
    if (!selectedFile) {
      dispatch(setMessage("Please select an image to search", "warning"));
      return;
    }

    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("top_k", 20); // Number of results to return
      formData.append("threshold", 0.1); // Similarity threshold

      const response = await axios.post(
        `http://127.0.0.1:8005/search-clip-resources`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }
      );

      //const data = await response.json();
  
      if (response.data) {
        setSearchResults(response.data.results);
        dispatch(setMessage(`Found ${response.data.total} similar resources`, "success"));
      } else {
        throw new Error("Search failed");
      }
    } catch (error) {
      dispatch(setMessage(error.message, "danger"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout>
      <header className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fs-5">Search Similar Resources</h2>
        <Link className="btn btn-outline-secondary" to="/resources">
          Back to Resources
        </Link>
      </header>

      {message && (
        <div className="mb-4">
          <div className={`alert alert-${messageType}`} role="alert">
            {message}
          </div>
        </div>
      )}

      <div className="row mb-4">
        <div className="col-md-3">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title mb-3">Upload Image to Search</h5>
              <div className="mb-3">
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </div>
              {preview && (
                <div className="mb-3">
                  <img
                    src={preview}
                    alt="Preview"
                    className="rounded"
                    style={{ maxHeight: "300px" }}
                  />
                </div>
              )}
              <button
                className="btn btn-primary w-100"
                onClick={handleSearch}
                disabled={!selectedFile || isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    Searching...
                  </>
                ) : (
                  "Search Similar Images"
                )}
              </button>
            </div>
          </div>
        </div>

        <div className="col-md-9">
          {searchResults.length > 0 ? (
            <div className="row g-3">
              {searchResults.map((resource, index) => (
                <div key={index} className="col-md-3">
                  <div className="card h-100">
                    <div className="position-relative">
                      {resource?.thumbnail?.path ? (
                        <LazyLoadImage
                          alt={resource.name}
                          src={`${MEDIA_URL}${resource.thumbnail.path}`}
                          height={160}
                          // width="100%"
                          effect="blur"
                          className="card-img-top object-fit-cover mx-auto"
                        />
                      ) : (
                        <div className="bg-light text-center py-5">No Image</div>
                      )}
                      <div className="position-absolute top-0 end-0 m-2">
                        <span className="badge bg-primary">
                          {(resource.similarity_score * 100).toFixed(1)}%
                        </span>
                      </div>
                    </div>
                    <div className="card-body">
                      <h6 className="card-title">
                        <Link to={`/resources/view/${resource.resource_id}`}>
                          {resource.name}
                        </Link>
                      </h6>
                      <div className="small text-muted mb-2">
                        <span className="badge bg-secondary me-1">
                          {resource.status}
                        </span>
                        <TimeAgo date={resource.created_at} />
                      </div>
                      {resource.tags && resource.tags.length > 0 && (
                        <div className="mb-2">
                          {resource.tags.slice(0, 3).map((tag, idx) => (
                            <span
                              key={idx}
                              className="badge bg-light text-dark me-1"
                            >
                              {tag.name}
                            </span>
                          ))}
                          {resource.tags.length > 3 && (
                            <span className="badge bg-light text-dark">
                              +{resource.tags.length - 3}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            !isLoading && (
              <div className="text-center py-5">
                <p className="text-muted">
                  Upload an image to search for similar resources
                </p>
              </div>
            )
          )}
        </div>
      </div>
    </AuthLayout>
  );
}

function mapStateToProps(state) {
  const { token } = state.auth;
  const { message, messageType } = state.message;
  return {
    token,
    message,
    messageType,
  };
}

export default connect(mapStateToProps)(SimilarImage);
